<!-- 弹窗 -->
<template>
  <transition name="fade">
    <div class="zlr-modal"
         v-if="value"
         @click="maskHandle">
      <div class="zlr-modal-main"
           :style="{width}"
           @click.stop>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import './modal.less'
export default {
  name: 'zlr-modal',
  props: {
    value: {
      type: [Boolean],
      default: false
    },
    width: {
      type: [String],
      default: '100%'
    },
    maskClosable: {
      type: [Boolean],
      default: true
    }
  },
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    maskHandle () {
      if (this['maskClosable']) {
        this.$emit('input', false)
      }
    }
  },
  watch: {
    value (newValue) {
      this.$emit('on-change', newValue)
      if (newValue) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
